<template>
  <div style="display: contents">
    <SampleDescriptionGrid :dv="dv" />
    <EMSamplePreparation :dv="dv" :hidden-fields="hiddenFields" />
    <GridPreparationCryo
      v-if="showGridPrepCryo"
      :dv="dv"
      :validation-errors="validationErrors"
    />
    <GridPreparationRT
      v-if="showGridPrepRT"
      :dv="dv"
      :validation-errors="validationErrors"
    />
    <VitrificationCryoTEM
      v-if="showVitrification"
      :dv="dv"
      :validation-errors="validationErrors"
    />
    <FibMillingCryoTEM
      v-if="showFibmilling"
      :dv="dv"
      :validation-errors="validationErrors"
    />
    <ArrayTomographyDetails
      v-if="showArrayTomography"
      :dv="dv"
      :validation-errors="validationErrors"
    />
    <SampleLineageDescription :dv="dv" />
    <SampleLinkToELN :dv="dv" />
  </div>
</template>

<script>
import { useEMSampleValidation } from '@/composables/validation/sample/useSampleValidation'
import SampleDescriptionGrid from '../shared/SampleDescriptionGrid.vue'
import EMSamplePreparation from './EMSamplePreparation.vue'
import GridPreparationCryo from './GridPreparationCryo.vue'
import GridPreparationRT from './GridPreparationRT.vue'
import VitrificationCryoTEM from './VitrificationCryoTEM.vue'
import FibMillingCryoTEM from './FibMillingCryoTEM.vue'
import ArrayTomographyDetails from './ArrayTomographyDetails.vue'
import SampleLineageDescription from '../shared/SampleLineageDescription.vue'
import SampleLinkToELN from '../shared/SampleLinkToELN.vue'
export default {
  name: 'EMSample',
  components: {
    SampleDescriptionGrid,
    EMSamplePreparation,
    GridPreparationCryo,
    GridPreparationRT,
    VitrificationCryoTEM,
    FibMillingCryoTEM,
    ArrayTomographyDetails,
    SampleLineageDescription,
    SampleLinkToELN,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const {
      showGridPrepCryo,
      showGridPrepRT,
      showArrayTomography,
      showVitrification,
      showFibmilling,
      hiddenFields,
      validationErrors,
    } = useEMSampleValidation(props.dv)

    return {
      showGridPrepCryo,
      showGridPrepRT,
      showArrayTomography,
      showVitrification,
      showFibmilling,
      hiddenFields,
      validationErrors,
    }
  },
}
</script>
